import { createSelector } from 'reselect';

import { TRANSFER_STATES } from '../constant/transfer-states';

import { allowedSizeSelector } from '@app/selector/transfers';

const transferSelector = (state) => state.transfer;

export const transferUploadInProgress = createSelector(
  [transferSelector],
  (transfer) => {
    return [TRANSFER_STATES.STARTED, TRANSFER_STATES.PAUSED].includes(
      transfer.state
    );
  }
);

export const getRemainingSize = createSelector(
  transferSelector,
  allowedSizeSelector,
  (transfer, allowedSize) => {
    return allowedSize - transfer.totalSize;
  }
);

export const getIsForwardedTransfer = createSelector(
  [transferSelector],
  (transfer) => {
    return !!transfer.parent_id;
  }
);
